import { makeObservable, observable } from 'mobx'
import { type IInboxTreeCombine } from 'entities/Inbox'

export class InboxTree {
  id: string
  parent: number | string
  droppable: boolean
  text: string
  data: IInboxTreeCombine
  groupInbox?: IInboxTreeCombine

  constructor(item: IInboxTreeCombine, itemParent?: IInboxTreeCombine) {
    this.id = itemParent ? `${item.root_tree}_${itemParent.id}_${item.id}` : item.idTree
    this.parent = itemParent ? `${item.root_tree}_${itemParent.id}` : item.root_tree
    this.droppable = item.isGroupInbox
    this.text = item.name
    this.data = item
    this.groupInbox = itemParent

    makeObservable(this, {
      id: observable,
      parent: observable,
      data: observable,
    })
  }
}
